import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b95734"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "nav-icon fas fa-dice-d20" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "right fas fa-angle-left"
}
const _hoisted_3 = { class: "nav-item" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["nav-item", {'menu-open': _ctx.isMenuExtended}])
  }, [
    _createElementVNode("a", {
      class: _normalizeClass(["nav-link", {'active': _ctx.isMainActive || _ctx.isOneOfChildrenActive}]),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleMainMenuAction && _ctx.handleMainMenuAction(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.menuItem.name)), 1),
      (_ctx.isExpandable)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem.children, (item, index) => {
      return (_openBlock(), _createElementBlock("ul", {
        class: "nav nav-treeview",
        key: index
      }, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: item.path,
            class: "nav-link",
            exact: "",
            "exact-active-class": "active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass([item.icon ,'nav-icon'])
              }, null, 2),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.name)), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      ]))
    }), 128))
  ], 2))
}